import type { DatePreset, TournamentListParams } from './api';

/**
 * The tournament lists' query string, for `GET /api/tournaments` and a room's
 * `GET /api/rooms/{roomId}/tournaments`. Its own module, with type-only imports, so `node --test` can run it:
 * `api.ts` cannot be imported there.
 *
 * `tags` repeats rather than joining, which is what the model binder expects.
 */
export const tournamentQs = (
  params: TournamentListParams & { preset?: DatePreset; anyTags?: string[] },
): string => {
  const search = new URLSearchParams();
  if (params.roomId) search.set('roomId', params.roomId);
  if (params.preset) search.set('preset', params.preset);
  if (params.from) search.set('from', params.from);
  if (params.to) search.set('to', params.to);
  for (const tag of params.tags ?? []) search.append('tags', tag);
  for (const tag of params.excludeTags ?? []) search.append('excludeTags', tag);
  for (const tag of params.anyTags ?? []) search.append('anyTags', tag);
  if (params.page !== undefined) search.set('page', String(params.page));
  if (params.pageSize !== undefined) search.set('pageSize', String(params.pageSize));
  if (params.sort) search.set('sort', params.sort);
  if (params.dir) search.set('dir', params.dir);
  const s = search.toString();
  return s ? `?${s}` : '';
};
